/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';

export function DriftReportsPage() {
  const selectedTenantID = useMgmtPlaneStateStore((state) => state.selectedTenantID);
  const env = window.mimicConfig.MIMIC_MGMT_PLANE_ENVIRONMENT || 'dev';
  const dashcamSubdomain = window.mimicConfig.MIMIC_MGMT_PLANE_ENVIRONMENT === 'prod' ? 'auto-ir' : `auto-ir.${env}`;
  const reportSource = `https://${dashcamSubdomain}.mimic.com/drift-report-beta?tenant_id=${selectedTenantID}`;

  return (
    <iframe
      title="Drift Reports"
      style={{
        width: '100%',
        flex: 1,
        border: 'none',
      }}
      src={reportSource}
    />
  );
}
